"use client";

import GridColumn from "@/components/common/grid-column/grid-column";
import GridRow from "@/components/common/grid-row/grid-row";
import css from "./product-articles.module.scss";
import ProductArticleCard, {
  IProductArticleProps,
} from "./product-article-card/product-article-card";
import { useEffect, useState } from "react";
import { ArticleData } from "@/sanity/interfaces";
import { mapArticleInfo } from "@/utilities/resources";

interface IProductArticlesProps {
  data: ArticleData[];
  id?: string;
  articleName?: string;
}

const ProductArticles = (props: IProductArticlesProps) => {
  const { data, id } = props;
  const [articleInfo, setArticleInfo] = useState<IProductArticleProps[]>([]);
  const headerText = props?.articleName ?? "Related Articles";

  useEffect(() => {
    if (data) {
      setArticleInfo(mapArticleInfo(data));
    }
  }, [data]);

  if (articleInfo.length === 0) {
    return null;
  }

  return (
    <GridRow>
      <GridColumn>
        <div className={css.productArticlesHeader}>
          <h2 id={id} className="text-[28px] text-[#373A36]">
            {headerText}
          </h2>
          {/* DO NOT DELETE - for future use */}
          {/* <Link
            href="/recent-articles"
            linkType={LinkType.BUTTON}
            linkStyle={LinkStyle.SECONDARY}
            className={css.productArticlesViewAll}
          >
            <span>View All</span>
            <ArrowIcon />
          </Link> */}
        </div>
      </GridColumn>
      {articleInfo.map((item, index) => (
        <GridColumn key={index} lg={4}>
          <ProductArticleCard
            articleUrl={item.articleUrl}
            articleUrlText={item.articleUrlText}
            category={item.category}
            description={item.description}
            imageUrl={item.imageUrl}
            title={item.title}
            readMinutes={item.readMinutes}
            updatedDate={item.updatedDate}
          />
        </GridColumn>
      ))}
      {/* DO NOT DELETE - for future use */}
      {/* <GridColumn>
        <Link
          href="/recent-articles"
          linkType={LinkType.BUTTON}
          linkStyle={LinkStyle.SECONDARY}
          className={`${css.productArticlesViewAllMobile}`}
        >
          <span>View All</span>
          <ArrowIcon />
        </Link>
      </GridColumn> */}
    </GridRow>
  );
};

export default ProductArticles;
